<template>
  <div class="new-vehicle">
    <page-header
      title="Edit Fleet"
      breadcrumb="Dashboard > Settings > Fleet >  Edit Fleet"
    />

    <div class="card">
      <p class="text-primary-yellow font-semibold">Vehicle Name</p>
      <div class="mt-3 container-fluid">
        <div class="row">
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label">Vehicle Name</label>
            <input type="text" class="input" v-model="newVehicle.vehiclename" />
          </div>
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label">Vehicle Number</label>
            <input type="text" class="input" v-model="newVehicle.plateNumber" />
          </div>
          <!-- <div class="col-md-6 col-lg-4 col-12">
            <label class="label">Asset Tag</label>
            <input type="text" class="input" v-model="newVehicle.assettag" />
          </div> -->
        </div>
      </div>

      <hr class="mb-2" />

      <div class="vehicle-identification">
        <div class="mb-4">
          <p class="text-primary-yellow font-semibold">
            Vehicle Identification
          </p>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">VIN Number</label>
              <input type="text" class="input" v-model="newVehicle.vinnumber" />
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Chasis Number</label>
              <input
                type="text"
                class="input"
                v-model="newVehicle.chasisnumber"
              />
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Asset Tag</label>
              <input type="text" class="input" v-model="newVehicle.assettag" />
            </div>
          </div>
        </div>
      </div>

      <hr class="mb-2" />

      <div class="vehicle-capacity">
        <div class="mb-4">
          <p class="text-primary-yellow font-semibold">
            Vehicle Capacity
          </p>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Vehicle Type</label>
              <input
                type="text"
                class="input"
                v-model="newVehicle.vehicletype"
              />
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Max. Capacity (Tonnage)</label>
              <input
                type="text"
                class="input"
                v-model="newVehicle.maxcapacity"
              />
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Loading Capacity (Tonnage)</label>
              <input
                type="text"
                class="input"
                v-model="newVehicle.loadingcapacity"
              />
            </div>
          </div>
        </div>
      </div>

      <hr class="mb-2" />

      <div class="registered-to">
        <div class="mb-4">
          <p class="text-primary-yellow font-semibold">
            Registered To
          </p>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Routes</label>
              <!-- <input type="text" class="input" /> -->

              <el-select v-model="newVehicle.routes" placeholder="Select">
                <el-option
                  v-for="route in routes"
                  :key="route.id"
                  :label="route.routeName"
                  :value="route.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Terminals</label>
              <!-- <input type="text" class="input" v-model="newVehicle.terminals" /> -->
              <el-select v-model="newVehicle.terminals" placeholder="Select">
                <!-- <el-option
                  v-for="terminal in terminals"
                  :key="terminal.id"
                  :label="terminal.name"
                  :value="terminal.id"
                >
                </el-option> -->
                <el-option
                  :label="terminals.arrivalLocation"
                  :value="terminals.arrivalLocation"
                >
                </el-option>
                <el-option
                  :label="terminals.takeOffLocation"
                  :value="terminals.takeOffLocation"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <hr class="mb-4" />

      <div class="vehicle-particulars">
        <div class="flex justify-between">
          <p class="text-primary-yellow font-semibold">Vehicle Particulars</p>
          <base-button
            text="Add particulars"
            @click="addParticular('new Particular')"
          />
        </div>
        <div class="particulars-table">
          <table class="custom-table responsive-table">
            <thead>
              <tr class="shadow-table rounded-lg">
                <th>Vehicle Particulars</th>
                <th>Document Number</th>
                <th>Image</th>
                <th>Expiry Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr class="shadow-table rounded-lg">
                <td>License & Registration</td>
                <td>{{ licenseAndRegistration.documentnumber }}</td>
                <td class="text-primary-yellow font-semibold">
                  {{ licenseAndRegistration.imageName || "N/A" }}
                </td>
                <td>
                  <span v-if="licenseAndRegistration.expirydate">
                    {{
                      new Date(
                        Date.parse(licenseAndRegistration.expirydate)
                      ).toLocaleDateString("en-gb")
                    }}</span
                  >
                  <span v-else>-</span>
                </td>
                <td
                  class="update"
                  @click="addParticular('licenseAndRegistration')"
                >
                  <img src="@/assets/images/icons/add.svg" alt="add icon" />
                </td>
              </tr>
              <tr class="shadow-table rounded-lg">
                <td>Insurance cert.</td>
                <td>{{ insuranceCertificate.documentnumber }}</td>
                <td>{{ insuranceCertificate.imageName || "N/A" }}</td>
                <td>
                  <span v-if="insuranceCertificate.expirydate">
                    {{
                      new Date(
                        Date.parse(insuranceCertificate.expirydate)
                      ).toLocaleDateString("en-gb")
                    }}</span
                  >
                  <span v-else>-</span>
                </td>
                <td
                  class="update"
                  @click="addParticular('insuranceCertificate')"
                >
                  <img src="@/assets/images/icons/add.svg" alt="add icon" />
                </td>
              </tr>
              <tr class="shadow-table rounded-lg">
                <td>RWC</td>
                <td>{{ rwc.documentnumber }}</td>
                <td>{{ rwc.imageName || "N/A" }}</td>
                <td>
                  <span v-if="rwc.expirydate">
                    {{
                      new Date(Date.parse(rwc.expirydate)).toLocaleDateString(
                        "en-gb"
                      )
                    }}</span
                  >
                  <span v-else>-</span>
                </td>
                <td class="update" @click="addParticular('rwc')">
                  <img src="@/assets/images/icons/add.svg" alt="add icon" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <div>
          <p class="text-primary-yellow font-semibold cursor-pointer flex gap-2">
            <img src="@/assets/images/icons/add.svg" alt="add icon" />
            Add Another Permit Document
          </p>
        </div> -->
      </div>

      <div class="button-wrapper my-5">
        <button @click="$router.push({ name: 'Vehicles' })">
          Cancel
        </button>
        <base-button
          @click="createVehicleRequestPayload"
          :loading="creatingVehicle"
          text="Save"
        />
      </div>

      <add-particulars-modal
        :show-modal="isParticularsModal"
        @close-modal="isParticularsModal = false"
        :particulars-name="particularsName"
        @save-particulars="saveParticulars($event)"
      />
    </div>
  </div>
</template>

<script>
import AddParticularsModal from "../partials/AddParticularsModal";
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  components: {
    AddParticularsModal,
    PageHeader,
  },
  data() {
    return {
      newVehicle: {
        orgId: localStorage.getItem("organizationId"),
        vinnumber: "",
        vehiclename: "",
        chasisnumber: "",
        assettag: "",
        vehicletype: "",
        maxcapacity: "",
        terminals: "ff082a65-a6b9-42c7-92e8-be0dca3e6eb5",
        loadingcapacity: "",
        plateNumber: "",
        lrNumber: "",
        routes: "",
        vehicleparticulars: [],
      },
      // vehicle: {},
      licenseAndRegistration: {
        //   image: null,

        particulars: "",
        documentnumber: " ",
        imageurl: "",
        expirydate: "",
      },
      insuranceCertificate: {
        particular: "",
        documentnumber: "",
        // image: null,
        expirydate: null,
      },
      rwc: {
        particular: "",
        documentnumber: "",
        //  image: null,
        expirydate: null,
      },
      creatingVehicle: false,
      routes: [],
      // terminals: [],
      isParticularsModal: false,
      particularsName: "",
    };
  },
  mounted() {
    this.getAllRoutes();
    // this.getAllTerminals();
    this.vehicleId = localStorage.getItem("vehicleId");
    if (this.vehicleId) {
      this.getVehicleDetails();
    } else {
      this.$router.push({ name: "Vehicles" });
    }
  },
  computed: {
    disableButton() {
      return this.shouldDisableButton(this.newVehicle);
    },
    terminals() {
      let selectedRoute = this.routes.find(
        (route) => this.newVehicle.routes == route.id
      );
      if (selectedRoute) {
        return {
          arrivalLocation: selectedRoute.arrivalLocation,
          takeOffLocation: selectedRoute.takeOffLocation,
        };
      }
      return { arrivalLocation: null, takeOffLocation: null };
    },
  },
  methods: {
    async getVehicleDetails() {
      try {
        let response = await this.$_getSingleVehicle(this.vehicleId);
        this.newVehicle = this.vehicle = response.data.found;
      } catch (error) {
        this.handleError(error);
      }
    },
    createVehicleRequestPayload() {
      this.createVehicle();
    },
    async createVehicle() {
      this.creatingVehicle = true;
      this.vehicleparticulars = [];

      this.newVehicle.vehicleparticulars.push(this.licenseAndRegistration);
      this.newVehicle.vehicleparticulars.push(this.insuranceCertificate);
      this.newVehicle.vehicleparticulars.push(this.rwc);
      try {
        await this.$_updateVehicle(this.newVehicle);
        this.generateToast("Vehicle successfully updated!", "success");
        this.creatingVehicle = false;
        // this.resetInputFied();
        this.$router.push({ name: "Vehicles" });
      } catch (error) {
        this.handleError(error);
        this.creatingVehicle = false;
      }
    },
    async getAllRoutes() {
      try {
        let response = await this.$_getAllRoutes();
        console.log(response);
        this.routes = response.data.findRoute;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllTerminals() {
      try {
        let response = await this.$_getAllTerminals();
        console.log(response);
        // this.terminals = response.data.findRoute[0].terminal;
        this.createTerminalsArray(response.data.findRoute);
      } catch (error) {
        this.handleError(error);
      }
    },
    createTerminalsArray(terminals) {
      terminals.forEach((terminal) => {
        this.terminals.push(terminal.terminal[0]);
      });
      this.terminals = this.terminals.filter(Boolean);
    },
    resetInputFied() {
      this.newVehicle = {
        equipment: "",
        vinnumber: "",
        chassisnumber: "",
        assettag: "",
        terminals: "",
        routes: "",
        vehicletype: "",
        carriageCapacity: "",
        currentLoadCapacity: "",
        vehicleparticulars: [],
      };
    },
    addParticular(particularsName) {
      this.particularsName = particularsName;
      this.isParticularsModal = true;
    },
    saveParticulars(data) {
      if (data.name == "licenseAndRegistration") {
        this.licenseAndRegistration = {
          particulars: "Licence and Registration",
          ...data.particulars,
        };
      } else if (data.name == "insuranceCertificate") {
        this.insuranceCertificate = {
          particulars: "Insurance certificate",
          ...data.particulars,
        };
      } else {
        this.rwc = { particulars: "RWC", ...data.particulars };
      }
    },
  },
};
</script>

<style scoped>
.update {
  color: #f57a4d;
  font-weight: bold;
  cursor: pointer;
}
.w-30 {
  width: 30%;
}
</style>
